import React from "react";
import { Modal } from "react-bootstrap";

const InboxDetailModal = ({ showModal, handleCloseModal, selectedInbox }) => {
    return (
        <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton closeVariant="white" className="bg-dark border-warning border-bottom">
                <Modal.Title className="text-warning fw-bold" style={{ fontSize: "16px" }}>
                    {selectedInbox?.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-white">
                {selectedInbox?.imageurl && (
                    <img
                        src={selectedInbox.imageurl}
                        alt={selectedInbox.title}
                        className="img-fluid rounded w-100 mb-3"
                    />
                )}
                <div style={{ whiteSpace: "pre-wrap", fontSize: "14px", lineHeight: "1.5" }}>
                    {selectedInbox?.content}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default InboxDetailModal;
